import React, {Component, Fragment} from "react";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as common from "../../lib/common"
import { storedb } from '../../views/client/storedb'
import AppConfig from '../../config/app'

import * as orderActions from '../Order/actions'
import * as marketingOrderActions from './actions'
import { FormFiels } from '../Order/constants'
import marketingOrderConstants from './constants'

import OrderControls from './OrderControls'

class MarketingOrder extends Component {
  constructor(props) {
    super(props);
    let dbContext = storedb()
    this.state = {
      quantity: 1,
      is_km: 0,
      dvt: '',
      dvt_id: 0,
      item_id: '',
      product_id: 0,
      productCtl: {},
      customerCtl: {},
      hasChanged: false,
      isShowCkEditabled: false,
      storeId: dbContext.getStoreId(),
      showCkPercent: dbContext.getSettingValue(AppConfig.SETTINGKEYS.ShowCkPercent, "0"),
      customers: [],
      thuocs: [],
      users: [],
      khoXuats: [],
    }
  }

  checkTypeOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { id } = params;
      const mode = (id && id != '') ? marketingOrderConstants.MODE.IN_EDIT: marketingOrderConstants.MODE.IN_CREATE

      this.props.setMode(mode)
      this.props.setOrderId(id)

      callback(mode)
    }
  }

  return2List = () => {
    if (this.props.mode === marketingOrderConstants.MODE.IN_EDIT) {
      // neu o mode sua don can unlock don hang khi bam nut back
      const payload = {
        orderId: this.props.orderId
      }
      this.props.unlockOrder(payload, () => {
        this.gotoView()
      })
    } else {
      this.gotoList()
    }
  }
  gotoList = () => {
    const url = `/marketing-orders/`
    this.props.history.push(url)
  }
  gotoView = (data) => {
    // trở lại trang view
    const orderId = data ? data.Id : this.props.orderId
    const url = `/marketing-order-view/${orderId}`
    this.props.history.push(url);
  }
  onHandleClick = (usersChecked, isForceLoad) => {
    let userId = 0, tenUser = ''
    if (usersChecked && usersChecked.length > 0) {
      userId = usersChecked[0].value || 0
      tenUser = usersChecked[0].label
      this.props.setUsersChecked(usersChecked);
    } else {
      this.props.setUsersChecked([]);
    }
    this.updateInfor(FormFiels.NhanVienId, userId)
    this.updateInfor(FormFiels.TenNhanVien, tenUser)
    
    if (isForceLoad) {
      this.loadDataForNhanVien()
    }
  }
  onHandleRemove = (nodeChecked) => {
    let usersChecked = this.props.usersChecked;
    var index = usersChecked.findIndex(e => e.value == nodeChecked.value);
    if (index > -1) {
      usersChecked.splice(index, 1);
    }

    this.onHandleClick(usersChecked)
    this.loadDataForNhanVien()
  }
  onHandleChoice = (usersChecked) => {
    this.onHandleClick(usersChecked)
    this.loadDataForNhanVien()
  }
  loadDataForNhanVien = () => {
    const formData = {
      userId: this.props.orderInfor[FormFiels.NhanVienId],
      typeOfOrder: this.props.typeOfOrder
    }
    this.props.loadKhos(formData, (items) => {
      this.setState({khoXuats: items})
      let khoXuatId = 0, tenKhoXuat = ''
      if (items && items.length === 1) {
        khoXuatId = items[0]["Id"]
        tenKhoXuat = items[0]["Ten"]
      }
      this.updateInfor(FormFiels.KhoXuatId, khoXuatId)
      this.updateInfor(FormFiels.TenKhoXuat, tenKhoXuat)
    });
  }
  onCustomerTextChanged = (keyword, callback) => {
    const formData = {
      keyword: keyword
    }
    this.props.loadCustomers(formData, (items) => {
      this.setState({
        customers: items
      }, () => {
        if (callback) {
          callback()
        }
      })
    });
  }
  onCustomerSelectChanged = ({ref}) => {
    let {orderInfor} = this.props
    let addedCustomers = orderInfor.added_customers || []
    const index = addedCustomers.findIndex(x => x.Id === ref.Id)
    if (index >= 0) {
      return
    }
    ref.IsRemovable = true
    // merge item into the head of array
    addedCustomers = [ref].concat(addedCustomers)
    orderInfor.added_customers = addedCustomers
    this.setState({hasChanged: true}, () => {
      this.props.setOrderInfor(orderInfor)
    })
  }
  onRemoveCustomer = (customer) => {
    let {orderInfor} = this.props
    let addedCustomers = orderInfor.added_customers || []
    orderInfor.added_customers = addedCustomers.filter(x => x.Id !== customer.Id)
    this.setState({hasChanged: true}, () => {
      this.props.setOrderInfor(orderInfor)
    })

  }
  formatOptionLabel = (option) => {
    return (
      <div className="item">
      <div>{option.label}</div>
      <span className={"text-mute item_unit"}>{'\u00A0'}{option.diaChi}</span>
    </div>
    )
  }

  formatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm khách hàng <i className="text-danger">#{input}</i></em>
      </Fragment>
    )
  }
  
  productHandleSelectChange = (selectedOption) => {
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    if (!khoXuatId || khoXuatId === '' 
      || isNaN(khoXuatId) || (+khoXuatId) <= 0) {
      this.props.setWarning('Chưa chọn kho xuất')
      this.state.productCtl.handleClearClick()
      return false
    }
    this.setState({ 
      dvt: selectedOption.dvt, 
      product_id: selectedOption.value 
    })
    this.props.setFlagAddItem(true)
  }
  thuocFormatOptionLabel = (option) => {
    let classPlus = ""
    if (option.quantity <= 0) {
      classPlus = "item_unit_0"
    } else if (option.quantity <= 100) {
      classPlus = "item_unit_100"
    }

    return (
      <div className="item">
      {'\u00A0'}{'\u00A0'}
      {option.label}
      <span className={`item_unit ${classPlus}`}>{'\u00A0'}({option.quantity || 0} {option.dvt})</span>
    </div>
    )
  }

  thuocFormatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm thấy sản phẩm <i className="text-danger">#{input}</i></em>
      </Fragment>
    )
  }
  thuocHandleChanged = (keyword, callback) => {
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    this.props.loadThuocs({
      store_id: this.state.storeId,
      kho_id: khoXuatId,
      keyword: keyword
    }, (items) => {
      this.setState({thuocs: items}, () => {
        if (callback) {
          callback()
        }
      })
    });
  }
  thuocHandleClearClick = e => {
    this.props.setFlagAddItem(false)
    this.props.setThuoc()
  }
  setProductCtl = (e) => {
    this.setState({productCtl: e});
  }
  setCustomerCtl = (e) => {
    this.setState({customerCtl: e});
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  handleAddItem = () => {
    if (!this.props.enabledAddItem) {
      return false
    }
    const khoXuatId = this.props.orderInfor[FormFiels.KhoXuatId]
    if (!khoXuatId || khoXuatId === '' 
      || isNaN(khoXuatId) || (+khoXuatId) <= 0) {
      this.props.setWarning('Chưa chọn kho xuất')
      return false
    }
    const { quantity, item_id, product_id, is_km } = this.state
    if (!product_id || product_id <= 0) {
      this.props.setWarning('Chưa chọn sản phẩm')
      return false;
    }
    if (quantity <= 0) {
      this.props.setWarning('Số lượng phải >= 1')
      return false;
    }

    const formData = {
      item_id: item_id,
      product_id: product_id,
      so_luong: quantity,
      kho_id: khoXuatId,
      is_km: is_km,
    }
    
    const loadSuccess = (data) => {
      this.resetFormItem()
      this.props.setFlagAddItem(false)
    }
    this.props.setWarning('')
    this.props.loadThuoc(formData, loadSuccess)
  }
  handleEditItem = (item) => {
    this.state.productCtl.setValueBox(item.ten)
    this.setState({
      quantity: item.so_luong,
      item_id: item.id,
      is_km: item.is_km,
      product_id: item.product_id,
    })
    this.props.setFlagAddItem(true)
  }
  handleRemoveItem = (item) => {
    let items = this.props.items
    const existed = items.findIndex(x => x.product_id === item.product_id && x.is_km === item.is_km)
    if (existed >= 0) {
      items.splice(existed, 1)
      this.props.setItems(items)
      this.resetFormItem()
      this.setState({hasChanged: true})
      // neu la sua don thi can canh bao de nguoi dung luu lại
      if (this.props.mode == marketingOrderConstants.MODE.IN_EDIT) {
        this.props.setWarning('Chú ý hành động chỉ xoá tạm thời, cần nhấn [Lưu] để hoàn tất')
      }
    }
  }

  resetFormItem = () => {
    this.props.setFlagAddItem(false)
    this.props.setThuoc()
    this.state.productCtl.handleClearClick()
    this.setState({ 
      quantity: 1, 
      is_km: 0,
      item_id: '', 
      product_id: 0, 
      dvt: '', 
      dvt_id: 0, 
      hasChanged: true 
    })
  }
  downQuantityClick = () => {
    const {quantity} = this.state
    if (quantity === 1) {
      return
    }
    this.setState({quantity: quantity - 1})
    this.props.setWarning('')
  }
  upQuantityClick = () => {
    const {quantity} = this.state
    this.setState({quantity: quantity + 1})
    this.props.setWarning('')
  }

  handleCkChange = (item, e) => {
    if (e.floatValue < 0) {
      return
    }
    const isUsePercent = this.state.showCkPercent === "1"
    if (isUsePercent) {
      // check over 100
      if (e.floatValue > 100) {
        return
      }
    }
    let items = this.props.items
    const existed = items.findIndex(x => x.product_id === item.product_id && x.is_km === item.is_km)
    if (existed >= 0) {
      if (!isUsePercent) {
        // check over tong_tien
        if (e.floatValue < items[existed].thanh_tien) {
          return
        }
      }
      items[existed] = this.reItemCals(items[existed], e.floatValue, isUsePercent)
      this.props.setItems(items)
      this.setState({hasChanged: true})
    }
  }
  reItemCals= (item, ckValue, isUsePercent) => {
    item.chiet_khau = ckValue
    const quantity = item.so_luong || 0;
    const price = item.gia_ban || 0;
    let totalPrice = quantity * price
    if (isUsePercent) {
      totalPrice = totalPrice - totalPrice * (ckValue / 100)
    } else  {
      totalPrice = totalPrice - ckValue
    }
    item.thanh_tien = totalPrice
    return item
  }
  handleQuantityChange = (e) => {
    let quantity = ''
    if (e && e.value && !isNaN(e.value)) {
      quantity = +e.value
    }
    if (quantity < 1) {
      quantity = 1
    }
    this.setState({quantity: quantity})
    this.props.setWarning('')
  }
  handleIsKMChange = (isChecked) => {
    this.setState({is_km: isChecked ? 1 : 0})
  }
  handleQuantityKeyPress = (e) => {
    // neu enter thi goi vao nut add item
    if(e.keyCode == 13){
       this.handleAddItem()
    }
  }
  handleDateCreated = (e) => {
    this.updateInfor(FormFiels.NgayLap, e)
  }
  handleNoteCreated = ({target}) => {
    this.updateInfor(FormFiels.GhiChu, target.value)
  }

  handleBoCkCreated = ({target}) => {
    this.updateInfor(FormFiels.BoChietKhau, target.checked)
  }

  handleXuatHDCreated = ({target}) => {
    this.updateInfor(FormFiels.XuatHoaDon, target.checked)
  }
  handleKhoChange = ({target}) => {
    const khoId = target.value || 0
    const kho = this.getKho(khoId)
    this.updateInfor(FormFiels.KhoXuatId, khoId)
    this.updateInfor(FormFiels.TenKhoXuat, kho.Ten)
    this.props.setWarning('')
  }
  getKho = (khoId) => {
    const kho = this.state.khoXuats.find(x => x.Id == khoId)
    return kho || {}
  }
  updateInfor = (key, value) => {
    const {hasChanged} = this.state
    let orderInfor = this.props.orderInfor
    orderInfor[key] = value
    this.props.setOrderInfor(orderInfor)
    this.setState({hasChanged: !hasChanged})
  }
  validForm = () => {
    const orderInfor = this.props.orderInfor
    const items = this.props.items || []
    const addedCustomers = orderInfor.added_customers
    const sumFee = common.sum(items, "thanh_tien")
    if (!orderInfor[FormFiels.NhanVienId] || orderInfor[FormFiels.NhanVienId] === '') {
      this.props.setError("Chưa chọn nhân viên")
      return false
    }
    if (!orderInfor[FormFiels.KhoXuatId] || orderInfor[FormFiels.KhoXuatId] === '') {
      this.props.setError("Chưa chọn kho xuất")
      return false
    }
    if (!addedCustomers || addedCustomers.length === 0) {
      this.props.setError("Chưa chọn khách hàng")
      return false
    }
    if (sumFee < 0) {
      this.props.setError("Tổng tiền đơn hàng phải >=0")
      return false
    }
    return true
    
  }
  saveOrder = e => {
    if (!this.validForm()) return false
    const callback = (data) => {
      setTimeout(e => {
        this.resetForm()
        this.gotoView(data)
      }, 1500)
    }
    const {orderInfor, typeOfOrder} = this.props
    const customerIds = orderInfor.added_customers.map(x => { return x.Id});
    const postData = {
      items: this.props.items,
      orderInfor,
      typeOfOrder,
      lstCustomer: customerIds
    }
    this.props.saveOrder(postData, callback)
  }
  resetForm = e => {
    this.props.resetForm()
  }
  showDialogLockPushOrder = (msg) => {
    msg = msg || 'Hiện tại hệ thống đang khoá chức năng đặt đơn'
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>{msg}</p>
            <button className="text-danger" onClick={() => {
              this.return2List()
              onClose()
            }}>Quay về</button>
          </div>
        )
      }
    })
  }
  checkCanPushOrder = (mode) => {
    // kiem tra xem co cho dat don hay khong
    const requestForm = {
      store_id: this.state.storeId
    }
    this.props.canPushOrder(requestForm, (responseData) => {
      if (responseData && responseData === true) {
        this.prepareOrder(mode)
      } else {
        this.showDialogLockPushOrder()
      }
    })
  }
  prepareOrder = (mode) => {
    if (mode === marketingOrderConstants.MODE.IN_EDIT) {
      const  payload = {
        orderId: this.props.orderId,
        mode
      }
      const callback = {
        onSuccess: (data) => {

        },
        onError: (message) => {
          this.showDialogLockPushOrder(message)
        }
      }
      this.props.getOrderDetails(payload, callback)
    } else {
      this.props.loadUsers({
        store_id: this.state.storeId,
        is_only_inherit: false,
      }, (users) => {
        // xu ly logic khi load users xong tu server
        this.setState({users})
      });
      this.props.loadThuocs({
        store_id: this.state.storeId,
        keyword: ''
      });
    }
  }
  componentWillMount() {
    const checkTypeCallback = (mode) => {
      this.checkCanPushOrder(mode)
    }
    this.checkTypeOrder(checkTypeCallback)
  }
  componentWillUnmount(){
    this.resetForm()
  }
  render() {
    return (
      <div className="animated fadeIn order">
        <OrderControls 
          requesting={this.props.requesting}
          warnings={this.props.warnings}
          messages={this.props.messages}
          errors={this.props.errors}
          mode={this.props.mode}
          orderId={this.props.orderId}
          orderInfor={this.props.orderInfor}
          khoXuats={this.state.khoXuats}
          thuocs={this.state.thuocs}
          users={this.state.users}
          customers={this.state.customers}
          usersChecked={this.props.usersChecked}
          enabledAddItem={this.props.enabledAddItem}
          items={this.props.items}
          isShowCKPercent={this.state.showCkPercent === "1"}
          isShowCkEditabled={this.state.isShowCkEditabled}
          quantity={this.state.quantity}
          isKM={this.state.is_km == 1}
          typeOfOrder={this.props.typeOfOrder}
          toggleEditCk={this.toggleEditCk}
          handleKhoChange={this.handleKhoChange}
          onHandleClick={this.onHandleClick}
          onHandleRemove={this.onHandleRemove}
          onHandleChoice={this.onHandleChoice}
          formatOptionLabel={this.formatOptionLabel}
          formatNoOptionLabel={this.formatNoOptionLabel}
          onCustomerSelectChanged={this.onCustomerSelectChanged}
          onRemoveCustomer={this.onRemoveCustomer}
          onCustomerTextChanged={this.onCustomerTextChanged}
          formatNoOptionLabel={this.formatNoOptionLabel}
          handleDateCreated={this.handleDateCreated}
          thuocFormatOptionLabel={this.thuocFormatOptionLabel}
          thuocFormatNoOptionLabel={this.thuocFormatNoOptionLabel}
          thuocHandleClearClick={this.thuocHandleClearClick}
          thuocHandleChanged={this.thuocHandleChanged}
          productHandleSelectChange={this.productHandleSelectChange}
          setProductCtl={this.setProductCtl}
          setCustomerCtl={this.setCustomerCtl}
          numberOnclick={this.numberOnclick}
          handleQuantityChange={this.handleQuantityChange}
          handleIsKMChange={this.handleIsKMChange}
          upQuantityClick={this.upQuantityClick}
          downQuantityClick={this.downQuantityClick}
          handleQuantityKeyPress={this.handleQuantityKeyPress}
          handleAddItem={this.handleAddItem}
          handleEditItem={this.handleEditItem}
          handleRemoveItem={this.handleRemoveItem}
          save={this.saveOrder}
          return2List={this.return2List}
          handleNoteCreated={this.handleNoteCreated}
          handleBoCkCreated={this.handleBoCkCreated}
          handleXuatHDCreated={this.handleXuatHDCreated}
          handleCkChange={this.handleCkChange}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  users: state.marketingOrder.users,
  usersChecked: state.marketingOrder.usersChecked,
  customers: state.marketingOrder.customers,
  customerInfor: state.marketingOrder.customerInfor,
  orderInfor: state.marketingOrder.orderInfor,
  thuocs: state.marketingOrder.thuocs,
  thuocInfor: state.marketingOrder.thuocInfor,
  errors: state.marketingOrder.errors,
  messages: state.marketingOrder.messages,
  warnings: state.marketingOrder.warnings,
  requesting: state.marketingOrder.requesting,
  enabledAddItem: state.marketingOrder.enabledAddItem,
  items: state.marketingOrder.items,
  typeOfOrder: state.marketingOrder.typeOfOrder,
  mode: state.marketingOrder.mode,
  orderId: state.marketingOrder.orderId,
})

const connected = connect(mapStateToProps, 
  {
    setUsersChecked: marketingOrderActions.setUsersChecked,
    loadCustomers: marketingOrderActions.loadCustomers,
    loadThuoc: marketingOrderActions.loadThuoc,
    loadThuocs: orderActions.loadThuocs,
    loadUsers: orderActions.loadUsers,
    loadKhos: orderActions.loadKhos,
    setFlagAddItem: marketingOrderActions.setFlagAddItem,
    setIsLoading: marketingOrderActions.setIsLoading,
    setWarning: marketingOrderActions.setWarning,
    setError: marketingOrderActions.setError,
    setItems: marketingOrderActions.setItems,
    setOrderInfor: marketingOrderActions.setOrderInfor,
    saveOrder: marketingOrderActions.saveOrder,
    setThuoc: marketingOrderActions.setThuoc,
    resetForm: marketingOrderActions.resetForm,
    setMode: marketingOrderActions.setMode,
    setOrderId: marketingOrderActions.setOrderId,
    getOrderDetails: marketingOrderActions.getOrderDetails,
    setCallbackFunc: marketingOrderActions.setCallbackFunc,
    unlockOrder: marketingOrderActions.unlockOrder,
    canPushOrder: orderActions.canPushOrder,
  })(MarketingOrder)

const formed = reduxForm({
  form: 'marketingOrder',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/MarketingOrder/MarketingOrder.js